export const cookies = {
  AUTH_TOKEN: 'red_career_admin_auth_token',
  WELCOME_CLOSED: 'red_career_admin_welcome_closed', // true or undefined
  MAINTENANCE_MESSAGE_CLOSED: 'red_career_admin_maintenance_message_closed', // true or undefined
}
